/**
 * Handles all focus to anchor
 * @module enabledButton to
 */

import $ from 'jquery';
import 'jquery-mask-plugin';
import registerJQueryPlugin from '../lib/register-jquery-plugin';
import mergeOptions from '../lib/merge-options.js';

// Expose the function as a jQuery plugin for ease of uses
export const PLUGIN_NAME = 'enabledButton';
export const DEFAULTS = {
  ebRequiredInputs: '',
  ebAtLeastOne: false,
};

/**
 * Check if any inputs has a value
 * @param  {jQuery} $el - the disabled button
 * @param  {Array} inputArrays - array of inputs
 */
const atLeastOne = ($el, inputArrays) => {
  let hasValue = false;
  inputArrays.forEach((el) => {
    if ($(el).val() && !hasValue) {
      hasValue = true;
    }
  });
  if (hasValue) {
    $el.prop('disabled', false);
  } else {
    $el.prop('disabled', true);
  }
};
/**
 * Check if any inputs has a value
 * @param  {jQuery} $el - the disabled button
 * @param  {regex} pattern - regex pattern
 * * @param  {val} string - input value
 */
const validatePattern = ($el, pattern, val) => {
  const re = new RegExp(pattern);
  if (re.test(val)) {
    $el.prop('disabled', false);
  } else {
    $el.prop('disabled', true);
  }
};

/**
 * Add Event Listeners to inputs
 * can be set.
 * @param  {jQuery} $el - button /element that opens modal
 * @param  {Object} opts - Any options provided upon initialization
 */
const addEventListerners = ($el, opts = {}) => {
  const { ebRequiredInputs, ebAtLeastOne } = opts;
  const inputArrays = ebRequiredInputs.split(',');
  inputArrays.forEach((el) => {
    const $input = $(el);
    const pattern = $input.attr('pattern');
    $input.on('keyup', () => {
      if (ebAtLeastOne) {
        atLeastOne($el, inputArrays);
      } else if (pattern) {
        validatePattern($el, pattern, $input.val());
      }
    });
  });
};

/**
 * Initializes focusTo.
 * @param {HTMLElement} el - button /element that opens focusTo
 * @param {Object} options - Options used for wiring up the focusTo
 * @see DEFAULTS
 */
export default function enabledButton(el, options = {}) {
  const $el = $(el);
  const opts = mergeOptions(DEFAULTS, options, $el);
  addEventListerners($el, opts);
}

registerJQueryPlugin(PLUGIN_NAME, enabledButton);



// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/enabled-button.js